import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.54 6.034c-.739.242-.696 1.28.059 1.442.29.062 16.512.062 16.802 0a.743.743 0 0 0 .589-.82c-.024-.207-.104-.334-.326-.514l-.151-.122-8.447-.006c-4.645-.004-8.482.005-8.526.02m.031 5.245c-.176.042-.305.132-.438.307-.098.128-.113.183-.113.417 0 .24.013.286.122.423a1.1 1.1 0 0 0 .299.244l.176.09h16.766l.176-.09a1.1 1.1 0 0 0 .299-.244c.109-.137.122-.182.122-.426 0-.245-.012-.288-.124-.426a1.2 1.2 0 0 0-.26-.234c-.135-.079-.214-.08-8.516-.086-4.609-.004-8.438.008-8.509.025m-.151 5.304a.66.66 0 0 0-.345.357.75.75 0 0 0-.02.591 1 1 0 0 0 .438.427C3.571 17.987 6.177 18 12 18s8.429-.013 8.507-.042a1 1 0 0 0 .438-.427.73.73 0 0 0-.007-.561.64.64 0 0 0-.346-.374c-.145-.074-.386-.076-8.6-.076-7.586 0-8.464.007-8.572.063" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "menu"}) } }